"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Tooltip_1 = require("../Tooltip");
function ElementDropdown({ element, dropdown, placement, activeStateHandler, hideOnSelect, disabled, }) {
    return (react_1.default.createElement(Tooltip_1.Tooltip, { hideOnSelect: hideOnSelect, showOn: "click", placement: placement, contentNode: dropdown, activeStateHandler: activeStateHandler, disabled: disabled }, element));
}
ElementDropdown.defaultProps = {
    hideOnSelect: undefined,
    disabled: false,
};
exports.default = ElementDropdown;
